// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1E_V4","selected":"Chip_selected__2ZLSf"};